import TopVideos30dPanel from "@/components/TopVideos30dPanel";

export default function TopVideos30d() {
  return (
    <div
      data-testid="top-videos-30d-page"
      className="px-6 lg:px-10 py-8 max-w-[1300px] mx-auto"
    >
      <div className="font-mono text-xs uppercase tracking-[0.3em] text-yellow-400 mb-3">
        // PHASE 1 · TOP VIDEOS · 30 DAYS
      </div>
      <TopVideos30dPanel embedded={false} />
    </div>
  );
}
